import React from 'react';
import styled from 'styled-components';
import {
  Absolute,
  Box,
  LinkComponent,
  Text,
} from '@rsos/components/capstone/base';

const Container = styled(Box).attrs({
  bg: 'foreground',
})``;

const MapUnavailable = () => {
  return (
    <Absolute width={'100%'} style={{ height: '100%' }}>
      <Container align="center" justify="center" grow height="100%">
        <Text fontWeight="bold" size="normal" textAlign="center" mb="14px">
          This indoor map
          <br />
          is not currently available
        </Text>
        <Text textAlign="center" size="small" inline>
          <Text inline>Try contacting our support staff at</Text>
          <br />
          <LinkComponent to="mailto:support@yrapidsos.com" type="secondary">
            support@rapidsos.com
          </LinkComponent>
        </Text>
      </Container>
    </Absolute>
  );
};

export default MapUnavailable;
